module.exports = __webpack_public_path__ + "img/shenhe_gzh.0547b1bc.jpg";